import React from 'react';

export interface TemplateContextValue {
  contentType: string;
  /**
   * Per-page override that suppresses the site-wide top banner on this page,
   * regardless of the banner's `show_on_content_types` setting. Set from the
   * page's `hide_top_banner` field in Storyblok.
   */
  hideTopBanner?: boolean;
}

const TemplateContext = React.createContext<TemplateContextValue>({
  contentType: '',
  hideTopBanner: false,
});

export default TemplateContext;
